module.exports = __webpack_public_path__ + "static/media/ExcelIcon.97eae0da.svg";